var map = {
	"./confluxScanIcon.svg": 4028,
	"./discordIcon.svg": 9439,
	"./favoriteIcon.svg": 6683,
	"./followIcon.svg": 7519,
	"./instagramIcon.svg": 5170,
	"./telegramIcon.svg": 3501,
	"./twitterIcon.svg": 2741,
	"./websiteIcon.svg": 6747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4276;